import React, { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import Topbar from "../Topbar/Topbar";
import "./Dues.css";
import Swal from "sweetalert2";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDownloadExcel } from "react-export-table-to-excel";
import Map from '../images/mapicon.svg'

const statusOptions = [
  { value: "Open", color: "#fbdc6e" },
  { value: "Paid", color: "#a7e9a1" },
  { value: "Reminder 1", color: "#c4a5f3" },
  { value: "Reminder 2", color: "#c7a47b" },
  { value: "Reminder 3", color: "#f9b2e2" },
  { value: "> 3 Reminder", color: "#e66767" },
  { value: "Suspended", color: "#c0c3ca" },
  { value: "Disable", color: "#fca672" },
];

export default function Dues() {
  const permissions = useSelector((state) => state.permissions);
  const designation = useSelector((state) => state.designation);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [duesDataFetch, setDuesDataFetch] = useState([]);
  const [duesDelete, setDuesDelete] = useState(false);
  const navigate = useNavigate();

  const [duesFilter, setDuesFilter] = useState({
    duesId: "",
    dueStatus: "",
    invoiceDate: "",
    customername: "",
    contactnum: "",
    alternatenum: "",
    notes: "",
    followupPerson: "",
    totalBillAmount: "",
    dueAmount: "",
    expectedPaymentDate: "",
    delete: "",
  });

  const fiterSetting = duesDataFetch?.filter((dues) => {
    return Object.keys(duesFilter).every((key) => {
      const filterValue = duesFilter[key]?.toString().toLowerCase();
      const dataValue = dues[key]?.toString().toLowerCase();
      if (!filterValue) return true;
      return dataValue?.includes(filterValue);
    });
  });

  const [columnVisibility, setColumnVisibility] = useState({
    duesId: true,
    dueStatus: true,
    invoiceDate: true,
    customername: true,
    contactnum: true,
    alternatenum: true,
    notes: true,
    followupPerson: true,
    totalBillAmount: true,
    dueAmount: true,
    expectedPaymentDate: true,
    delete: true,
  });

  const [duesCounts, setDuesCounts] = useState({});

  const [duesSetting, setDuesSetting] = useState(false);

  //export
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Dues_data",
    sheet: "Dues",
  });
  const [shouldExport, setShouldExport] = useState(false);

  const handleExportConfirmation = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to export the Due details?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, export it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
        setShouldExport(true); // Allow the export to proceed
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "The export operation was cancelled.", "error");
        setShouldExport(false);
      }
    });
  };

  const getStatusColor = (status) => {
    const match = statusOptions.find((s) => s.value === status);
    return match ? match.color : "#ffffff"; // default color
  };

  const duesSettingPopup = (e) => {
    e.preventDefault();
    setDuesSetting(!duesSetting);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setDuesFilter((prevFilters) => ({
      ...prevFilters,
      [name]: value.toLowerCase(), // Normalize input for case-insensitive search
    }));
  };

  const handleColumnVisibilityChange = (e) => {
    const { name, checked } = e.target;
    setColumnVisibility((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  let changedata = (data) => {
    if (data === "duesId") {
      return "  Due Id";
    }
    if (data === "dueStatus") {
      return "Due Status";
    }
    if (data === "invoiceDate") {
      return "Invoice Date";
    }
    if (data === "customername") {
      return "Customer Name";
    }
    if (data === "contactnum") {
      return "contact Number";
    }
    if (data === "alternatenum") {
      return "Alternate Number";
    }

    if (data === "notes") {
      return "Notes";
    }

    if (data === "followupPerson") {
      return "Follow Up Person";
    }

    if (data === "totalBillAmount") {
      return "Total Bill Amount";
    }

    if (data === "dueAmount") {
      return " Due Amount";
    }

    if (data === "expectedPaymentDate") {
      return "Expected Payment Date";
    }

    if (data === "delete") {
      return "Delete";
    } else {
      return data;
    }
  };

  const add = () => {
    navigate("/adddues");
  };
  // edit

  const gotoViewDues = (id) => {
    navigate("/view_dues", {
      state: { id: id },
    });
  };
  const [phoneNumber1, setPhoneNumber1] = useState("");
  const [phoneNumber2, setPhoneNumber2] = useState("");
  const [email, setEmail] = useState("");
  //   const [errors, setErrors] = useState({});

  const phoneRegex = /^[7-9]{1}[0-9]{9}$/;

  // Regex for validating email
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phoneNumber1") {
      setPhoneNumber1(value);
    } else if (name === "phoneNumber2") {
      setPhoneNumber2(value);
    } else if (name === "email") {
      setEmail(value);
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate Phone Number 1
    if (!phoneRegex.test(phoneNumber1)) {
      newErrors.phoneNumber1 =
        "Please enter a valid 10-digit phone number (starting with 7-9)";
    }

    // Validate Phone Number 2 (Optional)
    if (phoneNumber2 && !phoneRegex.test(phoneNumber2)) {
      newErrors.phoneNumber2 =
        "Please enter a valid 10-digit phone number (starting with 7-9)";
    }

    // Validate Email
    if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address";
    }

    return newErrors;
  };

  const formatDateTime = (inputDate) => {
    if (!inputDate) return "Invalid Date";

    // Convert to Date object
    const date = new Date(inputDate);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();

    const now = new Date();
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    const time = `${hours}.${minutes} ${ampm}`;
    return `${day}-${month}-${year} / ${time}`;
  };

  const duesHandleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(apiUrl + `delete-dues/${id}`);
        Swal.fire("Deleted!", "Deleted Successfully.", "success");
        setDuesDelete((prev) => !prev); // ✅ toggles to trigger useEffect
      } catch (error) {
        Swal.fire("Error!", "Something went wrong while deleting.", "error");
        console.error("Delete Error:", error);
      }
    }
  };

  useEffect(() => {
    axios.get(apiUrl + "all-dues").then((res) => {
      setDuesDataFetch(res.data);
    });
  }, [duesDelete, apiUrl]);
  //statistics

  useEffect(() => {
    axios
      .get(apiUrl + "dues-status")
      .then((res) => {
        setDuesCounts(res.data);
      })
      .catch((err) => {
        console.error("Error fetching dues status:", err);
      });
  }, [apiUrl]);
   const handleMapClick = () => {
    navigate("/taskmapview?page=due");
  };
  return (
    <div className="customer-scroll-stop">
      <Topbar />
      <Container fluid className=" pt-1 customer-row ">
        <h3 className=" px-2  ">Dues</h3>
        {permissions?.Due?.["Due Statistics"]?.Read && (
          <Row className=" row-width">
            <Col className="dashborder mt-4   mb-5 mx-2 ">
              <Row className="yellow-card">
                <p
                  className="text-center box-txt "
                  style={{ marginTop: "6px" }}
                >
                  Open
                </p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{duesCounts["Open"] ?? 0}</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1  ">
              <Row className="green-card">
                <p className="text-center pt-1 box-txt">Paid</p>
              </Row>
              <Row className="number">
                <h5 className="text-center">{duesCounts["Paid"] ?? 0}</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5  mx-1">
              <Row className="purple-card ">
                <p className="text-center pt-1 box-txt">Reminder 1</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {duesCounts["Reminder 1"] ?? 0}
                </h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="brown-card row-margin">
                <p className="text-center pt-1 box-txt">Reminder 2</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {duesCounts["Reminder 2"] ?? 0}
                </h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="pink-card">
                <p
                  className="text-center pt-1 box-txt "
                  style={{ marginTop: "8px" }}
                >
                  Reminder 3
                </p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {duesCounts["Reminder 3"] ?? 0}
                </h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="red-card">
                <p className="text-center pt-1 px-1 box-txt"> > 3 Reminder </p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {duesCounts["> 3 Reminder"] ?? 0}
                </h5>
              </Row>{" "}
            </Col>
            <Col className="dashborder mx-1  mt-4 mb-5">
              <Row className="grey-card">
                <p className="text-center pt-1 box-txt">Suspended</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {duesCounts["Suspended"] ?? 0}
                </h5>
              </Row>
            </Col>
            <Col className="dashborder mx-1  mt-4 mb-5">
              <Row className="orange-card">
                <p className="text-center pt-1 box-txt">Disable</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {duesCounts["Disable"] ?? 0}
                </h5>
              </Row>
            </Col>
          </Row>
        )}

        <Row className=" button-bottom-custmer" xs={1} sm={2}>
          <Col className="mt-2 mb-2"  md={5}>
            {permissions?.Due?.["Add Due"]?.Write && (
              <button onClick={add} className="black-btn btnadd  black-btn1">
                Add
              </button>
            )}{" "}
            &emsp;&emsp;
            <button
              onClick={() => window.location.reload()}
              className="black-btn black-btn1"
            >
              Refresh
            </button>
          </Col>

          <Col className="btn-Ccolumn2 mt-2" md={6}>
            <button
              className="black-btn black-btn1 btnadd"
              onClick={
                designation === "Super Admin" && fiterSetting.length > 0
                  ? handleExportConfirmation
                  : undefined
              }
              disabled={
                designation !== "Super Admin" || fiterSetting.length === 0
              }
              style={{
                opacity:
                  designation === "Super Admin" && fiterSetting.length > 0,
                cursor:
                  designation === "Super Admin" && fiterSetting.length > 0
                    ? "pointer"
                    : "not-allowed",
              }}
              title={
                designation !== "Super Admin"
                  ? "Only Super Admin can export"
                  : fiterSetting.length === 0
                  ? "No data to export"
                  : "Export"
              }
            >
              Export
            </button>
            &emsp;&emsp;
            {permissions?.Due?.["Due Module"]?.Write && (
              <button
                onClick={duesSettingPopup}
                className="black-btn black-btn1 "
              >
                Settings
              </button>
            )}
            {duesSetting && (
              <div className="setting-popup-overlay">
                <div className="setting-popup-container">
                  <button
                    className="setting-close-btn"
                    onClick={duesSettingPopup}
                  >
                    &times;
                  </button>
                  <div className="setting-popup-content">
                    <div className="setting-checkbox-row">
                      <label>
                        <input
                          className="checkbox-customer"
                          type="checkbox"
                          checked={Object.values(columnVisibility).every(
                            (v) => v
                          )}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setColumnVisibility(
                              Object.keys(columnVisibility).reduce(
                                (acc, key) => {
                                  acc[key] = isChecked;
                                  return acc;
                                },
                                {}
                              )
                            );
                          }}
                        />
                        <span
                          className="checkbox-down ms-1"
                          style={{ fontSize: "17px" }}
                        >
                          {Object.values(columnVisibility).every((v) => v)
                            ? "Unselect All"
                            : "Select All"}
                        </span>
                      </label>
                    </div>

                    <div className="setting-checkbox-grid">
                      {Object.keys(columnVisibility).map((key) => (
                        <label key={key} className="label-setting-popup">
                          <input
                            type="checkbox"
                            name={key}
                            checked={columnVisibility[key]}
                            onChange={handleColumnVisibilityChange}
                            className="checbox-popup"
                          />
                          <span className="checkbox-down1">
                            {changedata(key)}
                          </span>
                        </label>
                      ))}
                    </div>

                    <button
                      className="setting-submit-btn"
                      onClick={duesSettingPopup}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
           
             

          </Col>
            <Col md={1}>
             {permissions?.Due?.["Map View"]?.Read && (
            <img src={Map} alt="map" style={{width:"30px",height:"30px"}}
            className="map-icon text-end"
            onClick={handleMapClick}/>
             )}
          </Col>
        </Row>

        <br />

        <div className="table-responsive">
          {permissions?.Due?.["Due Module"]?.Read && (
            <table ref={tableRef} className="table table-bordered table-sm">
              <thead className="table-th text-center">
                <tr>
                  {columnVisibility.duesId && (
                    <th className="table-th-content">Due ID</th>
                  )}
                  {columnVisibility.dueStatus && (
                    <th className="table-th-content">Due Status</th>
                  )}
                  {columnVisibility.invoiceDate && (
                    <th className="table-th-content">Invoice Date</th>
                  )}
                  {columnVisibility.customername && (
                    <th className="table-th-content">Customer Name</th>
                  )}
                  {columnVisibility.contactnum && (
                    <th className="table-th-content">Contact Number</th>
                  )}
                  {columnVisibility.alternatenum && (
                    <th className="table-th-content">Alternate Number</th>
                  )}

                  {columnVisibility.notes && (
                    <th className="table-th-content">Notes</th>
                  )}
                  {columnVisibility.followupPerson && (
                    <th className="table-th-content">Follow Up Person</th>
                  )}
                  {columnVisibility.totalBillAmount && (
                    <th className="table-th-content">Total Bill Amount</th>
                  )}
                  {columnVisibility.dueAmount && (
                    <th className="table-th-content">Due Amount</th>
                  )}
                  {columnVisibility.expectedPaymentDate && (
                    <th className="table-th-content">Expected Payment Date</th>
                  )}

                  {columnVisibility.delete &&
                    permissions?.Due?.["Due Module"]?.Delete && (
                      <th className="table-th-content">Delete</th>
                    )}
                </tr>
              </thead>

              <tbody>
                <tr>
                  {columnVisibility.duesId && (
                    <td>
                      <input
                        type="text"
                        className="table-search background-change"
                        onChange={handleFilterChange}
                        name="duesId"
                        placeholder="Search.."
                      />
                    </td>
                  )}
                  {columnVisibility.dueStatus && (
                    <td>
                      <select
                        className="table-search background-change"
                        onChange={handleFilterChange}
                        name="dueStatus"
                      >
                        <option value="">Select</option>
                        <option value="Open">Open</option>
                        <option value="Paid">Paid</option>
                        <option value="Disable">Disable</option>
                        <option value="Reminder 1">Reminder 1</option>
                        <option value="Reminder 2">Reminder 2</option>
                        <option value="Reminder 3">Reminder 3</option>
                        <option value="> 3 Reminder"> >3 Reminder </option>
                        <option value="Suspended">Suspended</option>
                      </select>
                    </td>
                  )}
                  {columnVisibility.invoiceDate && (
                    <td>
                      <input
                        className="table-search background-change"
                        onChange={handleFilterChange}
                        type="date"
                        name="invoiceDate"
                      />
                    </td>
                  )}
                  {columnVisibility.customername && (
                    <td>
                      <input
                        className="table-search background-change"
                        onChange={handleFilterChange}
                        type="text"
                        style={{ textTransform: "capitalize" }}
                        name="customername"
                        placeholder="Search"
                      />
                    </td>
                  )}
                  {columnVisibility.contactnum && (
                    <td>
                      <input
                        className="table-search background-change"
                        onChange={handleFilterChange}
                        type="tel"
                        onKeyDown={(e) => {
                          if (
                            ["e", "E", "+", "-"].includes(e.key) ||
                            (e.key &&
                              !/[0-9]/.test(e.key) &&
                              e.key !== "Backspace" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight")
                          ) {
                            e.preventDefault();
                          }
                        }}
                        style={{ textTransform: "capitalize" }}
                        name="contactnum"
                        placeholder="Search"
                      />
                    </td>
                  )}

                  {columnVisibility.alternatenum && (
                    <td>
                      <input
                        type="tel"
                        className="table-search background-change"
                        onChange={handleFilterChange}
                        name="alternatenum"
                        placeholder="Search"
                      />
                    </td>
                  )}



                  {columnVisibility.notes && <td></td>}

                  {columnVisibility.followupPerson && (
                    <td>
                      <select
                        className="table-search background-change"
                        onChange={handleFilterChange}
                        name="followupPerson"
                      >
                        <option value="">Select</option>
                        <option value="Saravanan">Saravanan</option>
                        <option value="Ravikumar">Ravikumar</option>
                        <option value="Santhosh">Santhosh</option>
                      </select>
                    </td>
                  )}

                  {columnVisibility.totalBillAmount && (
                    <td>
                      <input
                        type="tel"
                        onChange={handleFilterChange}
                        onKeyDown={(e) => {
                          if (
                            ["e", "E", "+", "-"].includes(e.key) ||
                            (e.key &&
                              !/[0-9]/.test(e.key) &&
                              e.key !== "Backspace" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight")
                          ) {
                            e.preventDefault();
                          }
                        }}
                        className="table-search background-change"
                        name="totalBillAmount"
                        placeholder="Search"
                      />
                    </td>
                  )}

                  {columnVisibility.dueAmount && (
                    <td>
                      <input
                        type="tel"
                        onChange={handleFilterChange}
                        onKeyDown={(e) => {
                          if (
                            ["e", "E", "+", "-"].includes(e.key) ||
                            (e.key &&
                              !/[0-9]/.test(e.key) &&
                              e.key !== "Backspace" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight")
                          ) {
                            e.preventDefault();
                          }
                        }}
                        className="table-search background-change"
                        name="dueAmount"
                        placeholder="Search"
                      />
                    </td>
                  )}

                

                  {columnVisibility.delete && <td></td>}
                </tr>

                {fiterSetting.length === 0 ? (
                  <tr>
                    <td colSpan="100%" style={{ textAlign: "center" }}>
                      No data found
                    </td>
                  </tr>
                ) : (
                  fiterSetting.map((d, i) => (
                    <tr key={i}>
                      {columnVisibility.duesId && (
                        <td
                          onClick={() => {
                            if (permissions?.Due?.["Due Module"]?.Write) {
                              gotoViewDues(d._id);
                            }
                          }}
                          style={{
                            cursor: permissions?.Due?.["Due Module"]?.Write
                              ? "pointer"
                              : "not-allowed",
                            padding: "10px",
                          }}
                        >
                          {" "}
                          {d.duesId}{" "}
                        </td>
                      )}

                      {columnVisibility.dueStatus && (
                        <td>
                          <span
                            style={{
                              backgroundColor: getStatusColor(d.dueStatus),
                              color: "#000",
                              padding: "6px 12px",
                              width: "100%",
                              borderRadius: "6px",
                              fontWeight: "500",
                              textTransform: "capitalize",
                              display: "inline-block",
                              textAlign: "center",
                            }}
                          >
                            {d.dueStatus}
                          </span>
                        </td>
                      )}

                      {columnVisibility.invoiceDate && (
                        <td>
                          {d.invoiceDate ? formatDateTime(d.invoiceDate) : "-"}
                        </td>
                      )}

                      {columnVisibility.customername && (
                        <td> {d.customername}</td>
                      )}

                      {columnVisibility.contactnum && <td> {d.contactnum}</td>}

                      {columnVisibility.alternatenum && (
                        <td>{d.alternatenum}</td>
                      )}

                      {columnVisibility.notes && (
                        <td>
                          {d.dueLeadstatus?.dueNotes?.length > 10 ? (
                            <>
                              {d.dueLeadstatus.dueNotes.slice(0, 10)}
                              <span
                                style={{
                                  fontSize: "20px",
                                  color: "#555",
                                  marginLeft: "2px",
                                }}
                              >
                                ...
                              </span>
                            </>
                          ) : (
                            d.dueLeadstatus?.dueNotes || ""
                          )}
                        </td>
                      )}

                      {columnVisibility.followupPerson && (
                        <td>{d.followupPerson} </td>
                      )}

                      {columnVisibility.totalBillAmount && (
                        <td> {d.totalBillAmount} </td>
                      )}

                      {columnVisibility.dueAmount && <td>{d.dueAmount} </td>}

                      {columnVisibility.expectedPaymentDate && (
                        <td>
                          {d.dueLeadstatus?.dueExpectedPaymentDate
                            ? formatDateTime(
                                d.dueLeadstatus.dueExpectedPaymentDate
                              )
                            : "-"}
                        </td>
                      )}

                      {columnVisibility.delete &&
                        permissions?.Due?.["Due Module"]?.Delete && (
                          <td>
                            <button
                              className="deletebtn-due"
                              onClick={() => duesHandleDelete(d._id)}
                            >
                              <MdDelete size={20} />
                            </button>
                          </td>
                        )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>
      </Container>
    </div>
  );
}
